<div class="copyImagesDialog">
    <div class="dialogHeader">
        <div class="headerDetails">
            <h2 mat-dialog-title class="headerTitle">Copy Images</h2>
            <span class="headerDescription"
                >Select images to copy to Set of
                {{
                    sumOfQuantity(variantImageModalData.currentVariantIndex)
                }}</span
            >
        </div>
        <div class="closeButton">
            <mat-icon (click)="close()">close</mat-icon>
        </div>
    </div>
    <hr />
    <ng-container *ngIf="allVariantImages.length > 0">
        <div class="imagesConatiner">
            <div class="imageTile" *ngFor="let imageId of allVariantImages">
                <mat-checkbox
                    class="img-checkbox"
                    [checked]="isSelected(imageId)"
                    (change)="toggleSelection(imageId)"
                    [disabled]="isTileDisabled(imageId)"
                ></mat-checkbox>
                <img
                    [src]="getImageUrl(imageId)"
                    class="product-image"
                    [alt]="imageId"
                />
            </div>
        </div>
        <hr />
    </ng-container>
    <div class="actions" mat-dialog-actions>
        <button
            class="button"
            [ngClass]="{
                'saveImagesButton-disable': selectedVariantImages.length === 0,
                'saveImagesButton-enable': selectedVariantImages.length > 0
            }"
            (click)="saveImages()"
        >
            Save Images
        </button>
    </div>
</div>
